module.exports = "/_next/static/images/experts-46cabc6ffac2b06586cf6fe9c3f316a6.svg";